<template>
  <div class="main">
    <sh-navbar :tab-title="tabTitle" :current-tab-index="currentTabIndex" :scroll-disabled="scrollDisabled" @tabChange="tabChange" @loadMore="loadMore">
      <template v-for="(item, index) in tabTitle">
        <invitation-item
          v-if="dataList.length > 0 && currentTabIndex === index"
          :key="index"
          :slot="`tab-cnt${index}`"
          :data-list="dataList"
          @entoDetailPage="entoDetailPage"
          @waitAudit="waitAudit"
          @checkInvitation="checkInvitation"
          @checkReward="checkReward"
          @checkReason="checkReason"
          @nowInvitation="nowInvitation"
          @submitAgian="submitAgian"
          @checkCancelReason="checkCancelReason"
        >
        </invitation-item>
      </template>
    </sh-navbar>
    <segement-Line v-if="!haveMore" line-text="没有更多订单了"> </segement-Line>
    <segement-Line v-else :is-load="true"> </segement-Line>
    <preview-dialog v-if="previewDialogShow" @close="previewDialogShow = false" :img-src="previewImgSrc"> </preview-dialog>
  </div>
</template>

<script>
import ShNavbar from '@/components/smartComponent/SHnavbar'
import InvitationItem from '@/components/smartComponent/InvitationItem'
import SegementLine from '@/components/puppetComponent/SegementLine'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import { Indicator, MessageBox, Toast } from 'mint-ui'
import { GetCanEvaluateOrderList, SAppEvaluateList, AuditNoPassRemarkGet, ShowEvaluatePic } from '@/api/invitation'

export default {
  data() {
    return {
      haveMore: false,
      scrollDisabled: false,
      tabTitle: ['待评价', '待审核', '已完成', '已取消'],
      currentTabIndex: 0,
      dataList: [],
      currentPage: 1,
      page: 1,
      pageCount: 1,
      previewImgSrc: '',
      previewDialogShow: false,
      loadCanEvaluateOrderList: false,
      canEvaluateOrderListApiParams: {
        page: 1
      }
    }
  },
  components: {
    ShNavbar,
    InvitationItem,
    SegementLine,
    PreviewDialog
  },
  mounted() {
    this.currentTabIndex = this.$route.query.tabIndex ? parseInt(this.$route.query.tabIndex) : 0
    if (this.currentTabIndex === 0) {
      this.fetchData()
    }
  },
  methods: {
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {
        EvaluateType: this.currentTabIndex,
        page: this.currentPage
      }
      this.haveMore = true
      this.scrollDisabled = true
      SAppEvaluateList(params)
        .then((res) => {
          Indicator.close()
          this.dataList = [...this.dataList, ...res.DataList]
          this.page = res.PaginationViewModel.Page
          this.pageCount = res.PaginationViewModel.PageCount
          if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
            if (this.currentTabIndex === 0) {
              this.getCanEvaluateOrderList()
            } else {
              this.haveMore = false
            }
          }
          this.currentPage = ++this.currentPage
          this.scrollDisabled = false
        })
        .catch((res) => {
          Indicator.close()
          this.haveMore = false
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
        })
    },
    getCanEvaluateOrderList() {
      GetCanEvaluateOrderList(this.canEvaluateOrderListApiParams).then((res) => {
        let list = res.Data.rows
        let total = res.Data.total
        this.dataList = [...this.dataList, ...list]
        if (this.dataList.length >= total) {
          this.haveMore = false
          return
        }
        this.canEvaluateOrderListApiParams.page = ++this.canEvaluateOrderListApiParams.page
      })
    },
    tabChange(val) {
      this.currentTabIndex = val
      this.dataList = []
      this.currentPage = 1
      this.canEvaluateOrderListApiParams = {
        page: 1
      }
      this.haveMore = true
      this.$router.replace({ name: 'invitationEvaluation', query: { tabIndex: val } })
      this.fetchData()
    },
    // 进入详情页
    entoDetailPage(productId) {
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productId
        }
      })
    },
    // 待审核
    waitAudit() {
      MessageBox({
        title: '提示',
        message: '评价已提交管理员审核，请耐心等待审核结果',
        confirmButtonText: '知道了',
        confirmButtonClass: 'c000'
      })
    },
    // 查看评价
    checkInvitation(id) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      ShowEvaluatePic({ id: id })
        .then((res) => {
          Indicator.close()
          this.previewImgSrc = res.Msg
          this.previewDialogShow = true
        })
        .catch((res) => {
          Indicator.close()
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
        })
    },
    // 查看奖励
    checkReward(id) {
      this.$router.push({
        name: 'freeCardDetail',
        query: {
          id: id
        }
      })
    },
    // 查看原因
    checkReason(id) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      AuditNoPassRemarkGet({ id: id })
        .then((res) => {
          Indicator.close()
          MessageBox({
            title: '审核不通过原因',
            message: res.Msg,
            confirmButtonText: '确定',
            confirmButtonClass: 'c000'
          })
        })
        .catch((res) => {
          Indicator.close()
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
        })
    },
    // 查看已取消原因
    checkCancelReason() {
      MessageBox({
        title: '已取消原因',
        message: '由于未及时完成评价/追评，评价邀请已被取消。下次记得快点来评价哦~',
        confirmButtonText: '确定',
        confirmButtonClass: 'c000'
      })
    },
    // 立即评价
    nowInvitation({ id = '', taskId = '' }) {
      console.log(id, taskId)
      this.$router.push({
        name: 'invitationSubmit',
        query: {
          id,
          taskId
        }
      })
    },
    // 重新提交
    submitAgian({ id = '', taskId = '' }) {
      this.$router.push({
        name: 'invitationSubmit',
        query: {
          id,
          taskId
        }
      })
    },
    loadMore() {
      if (!this.haveMore) {
        return
      }
      this.haveMore = true
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.main {
  min-height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
  font-size: 12px;
}
</style>
